/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {firstValueFrom} from 'rxjs';

import {ApiConfig} from '../../app/config/api-config';
import {LocalInactiveTargets} from '../session/local-inactive-targets';
import {AdnApiClientService} from '../../app/common/controller/adn-api-client.service';



export interface InactiveTargetsData {
  creatives?: any[];
  lineItems?: any[];
}

@Injectable()
export class AdnInactiveTargetsService {
  constructor(
    private readonly client: AdnApiClientService,
    private readonly apiConfig: ApiConfig,
    private readonly localInactiveTargets: LocalInactiveTargets
  ) {
  }

  cancelExistingData(id: string): void {
    const inactiveTargets = this.localInactiveTargets.getInactiveTargets();
    if (inactiveTargets) {
      let hasId = _.find(inactiveTargets.lineItems, (li: any) => {
        return _.get(li, ['lineItem', 'id']) === id;
      });
      if (!hasId) {
        hasId = _.find(inactiveTargets.creatives, (li: any) => {
          return _.get(li, ['creative', 'id']) === id;
        });
      }
      if (hasId) {
        this.localInactiveTargets.setInactiveTargets();
      }
    }
  }

  results(forceCall?: boolean): Promise<InactiveTargetsData> {
    const inactiveTargets = this.localInactiveTargets.getInactiveTargets(forceCall);
    if (inactiveTargets) {
      return Promise.resolve(inactiveTargets);
    }
    return firstValueFrom(this.client.request<InactiveTargetsData>({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['inactivetargets']),
      params: _.assign({}, {format: 'json'})
    })).then((response: any) => {
      const data: InactiveTargetsData = response || {creatives: [], lineItems: []};
      this.localInactiveTargets.setInactiveTargets(data);
      return data;
    }).catch(() => {
      return {creatives: [], lineItems: []};
    });
  }
}
